// OverlayGateway — Persistenz-Seam des Admin-Overlay-Stacks. Kapselt die AJAX-Endpunkte + Action-Namen
// an EINER Stelle (ajax.php · overlays_save_overlay · overlays_delete_overlay). Nutzt das globale jQuery
// (window.$) wie die übrigen Übergangsmodule.
//
// Bewusst NUR Transport: baut KEINE Payloads und behandelt KEINE Antworten — das bleibt beim Aufrufer
// (Controller). Jede Methode gibt das jqXHR/Promise zurück, der Aufrufer hängt `.done(...)` an. Das ist
// die Stelle, an der später a) Save/Delete über den Mediator-Bus laufen und b) im Dev ein anderer
// Persister (z.B. NoSQL) angekoppelt werden kann.

const AJAX_URL = '../../includes/ajax.php';
const ACTION_SAVE = 'overlays_save_overlay';     // generischer Spalten-Update (Save, Layer-Order, Sichtbarkeit)
const ACTION_DELETE = 'overlays_delete_overlay';

export function createOverlayGateway() {
    function post(data) {
        return window.$.ajax({
            url: AJAX_URL,
            cache: false,
            data: data,
            dataType: 'JSON',
            type: 'POST'
        });
    }

    return {
        // Speichert beliebige Overlay-Spalten; Save / Layer-Reihenfolge / Sichtbarkeit teilen sich den Endpoint.
        saveOverlays: function (data) { return post({ action: ACTION_SAVE, data: data }); },
        // Löscht ein Overlay endgültig.
        deleteOverlay: function (id) { return post({ action: ACTION_DELETE, id: id }); }
    };
}
